
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxMillau = () => {
  return (
    <CityMetauxPage
      cityName="Millau"
      departmentName="Aveyron"
      departmentCode="12"
      region="Occitanie"
      description="Située au cœur des Grands Causses, Millau bénéficie de notre expertise pour le rachat de métaux issus de l'industrie du cuir et de la métallurgie locale."
      specialities={[
        "Métaux de l'industrie du cuir et textile",
        "Équipements touristiques et sportifs",
        "Métaux de construction et BTP",
        "Ferraille agricole des causses"
      ]}
      nearbyAreas={[
        "Creissels", "Comprégnac", "Peyre", "Aguessac", "Rivière-sur-Tarn", "Saint-Rome-de-Tarn"
      ]}
      heroImage="https://images.unsplash.com/photo-1482938289607-e9573fc25ebb?w=1280&q=80"
    />
  );
};

export default AchatMetauxMillau;
